/**
 * Check whether an agent is already in a call.
 *
 * @param presence Presence object
 * @returns Boolean
 */
export function isAgentOnThePhone(presence) {
    return presence.presence_status.load_descriptions.some(({ load_type, conversation_channel }) => load_type !== 'nonlive' &&
        ['pstnphone', 'callback'].includes(conversation_channel));
}
